<script>
import Cookie from "js-cookie";
import Swal from "sweetalert2";
import axios from "axios";
import Pusher from "pusher-js";

/**
 * Topbar component
 */
export default {
  data() {
    return {
      notifications: [],
      totalNotif: 0,
      account: null
    };
  },
  mounted() {
    this.$store.dispatch('getNotification')
    this.subscribe()

    try {
      this.$firebase
        .messaging()
        .requestPermission()
        .then(() => {
          console.log("Notification permission granted");

          this.$firebase
            .messaging()
            .onMessage((payload) => {
              console.log("payload notification ", payload);
              this.$store.dispatch('getNotification')
            });
          
          this.$firebase
            .messaging()
            .getToken()
            .then((token) => {
              this.subscribeTopic(token)
            });
        })
        .catch((err) => {
          console.log("Unable to get token ", err);
        });
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    logoutUser() {
      Swal.fire({
        title: "Apakah Anda yakin ingin keluar ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Batal",
        confirmButtonText: "Ya"
      }).then(result => {
        if (result.value) {
          Cookie.remove("userdata");
          this.$store.commit("SET_LOGIN", null);
          this.$router.push("/login");
        }
      });
    },
    forceLogout() {
      this.$refs.modalAccount.hide();
      Cookie.remove("userdata");
      this.$store.commit("SET_LOGIN", null);
      this.$router.push("/login");
    },
    subscribeTopic(token) {
      axios.post(`https://iid.googleapis.com/iid/v1/${token}/rel/topics/${this.$store.state.userdata.id}`, {}, {
        headers: {
          Authorization: 'key=' + process.env.VUE_APP_FIREBASE_APP_SERVER
        }
      }).then(response => {
        console.log(response.data)
      }).catch(error => {
        console.error(error);
      })
    },
    async seeDetail(notif) {
      await this.$axios.get(`/v1/notification/${notif.id}`).then(response => console.log(response.data))
      this.$store.dispatch('getNotification')
      if (notif.data.type === 'registration_lc') {
        window.open(`/profile-update`, '_blank')
      } else if (notif.data.type === 'profile') {
        window.open(`/profile`, '_blank')
      }else {
        window.open(`/job/${notif.data.id}`, '_blank')
      }
    },
    subscribe() {
      const pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, { cluster: process.env.VUE_APP_PUSHER_CLUSTER })
      pusher.subscribe(`user-${this.$store.state.userdata.id}`)
      pusher.bind('profile-updated', (data) => {
        console.log('profile-updated', data)
        this.account = data
        if (data.account_status !== 'aktif' || data.document_status === 'ditolak') {
          this.$refs.modalAccount.show();
        }
      })
    }
  }
};
</script>
<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link tag="a" to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/logo.png" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/logo-lc.png" alt height="17" />
            </span>
          </router-link>

          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/logo.png" alt height="30" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/logo-lc.png" alt height="38" />
            </span>
          </router-link>
        </div>

        <button
          type="button"
          class="btn btn-sm px-3 font-size-24 header-item"
          id="vertical-menu-btn"
          @click="toggleMenu()"
        >
          <i class="mdi mdi-menu"></i>
        </button>
      </div>

      <div class="d-flex">
        <b-dropdown
          class="d-inline-block"
          toggle-class="header-item noti-icon"
          menu-class="dropdown-menu-lg p-0"
          right
          variant="white"
        >
          <template v-slot:button-content>
            <i class="mdi mdi-bell-outline"></i>
            <span class="badge badge-warning badge-pill" v-if="$store.state.totalNotif > 0">{{ $store.state.totalNotif }}</span>
          </template>
          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h5 class="m-0 font-size-16">
                  Notifications <span v-if="$store.state.totalNotif > 0">({{ $store.state.totalNotif }})</span>
                </h5>
              </div>
            </div>
          </div>
          <div data-simplebar style="max-height: 230px; overflow-y: auto;">
            <div class="text-reset notification-item cursor-pointer" v-for="(notif, index) in $store.state.notifications" :key="index">
              <div class="media" @click="seeDetail(notif)">
                <div class="avatar-xs mr-3">
                  <span class="avatar-title bg-danger rounded-circle font-size-16">
                    <i class="mdi mdi-message-text-outline"></i>
                  </span>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1">{{ notif.subject }}</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">{{ notif.created_at | date_time }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pt-2">
            <b-button
              type="button"
              to="/notification"
              variant="danger"
              class="w-100"
            >
              Lihat Semua
            </b-button>
          </div>
        </b-dropdown>

        <b-dropdown class="d-inline-block" right toggle-class="header-item" variant="white">
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile-user"
              :src="$store.getters.photo_profile"
              alt="Header Avatar"
            />
          </template>
          <b-link class="dropdown-item" to="/profile">
            <i class="mdi mdi-account-circle font-size-17 align-middle mr-1"></i> {{ $t('header.profile') }}
          </b-link>
          <div class="dropdown-divider"></div>
          <b-link class="dropdown-item text-danger" @click="logoutUser">
            <i class="bx bx-power-off font-size-17 align-middle mr-1 text-danger"></i> {{ $t('header.logout') }}
          </b-link>
        </b-dropdown>
      </div>
    </div>
    <!-- modal preview document -->
    <b-modal title="Warning" ref="modalAccount" id="modal-account" hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="row">
        <div class="col-lg-12 text-center font-size-24 font-weight-bold" v-if="account">
          <div v-if="account.account_status !== 'aktif'">
            Akun Anda tidak dapat diakses karena status akun Anda telah <span class="text-danger">{{ account.account_status }}</span>, silakan hubungi Admin
          </div>
          <div v-else-if="account.document_status == 'ditolak'">
            Akun Anda tidak dapat diakses karena dokumen legalitas Anda telah ditolak dengan alasan <span class="text-danger">{{ account.reject_reason }}</span>, silakan hubungi Admin
          </div>
        </div>

        <div class="w-100 d-flex justify-content-around mt-3">
          <b-button type="button" class="w-50" variant="danger" @click="forceLogout">OK</b-button>
        </div>
      </div>
    </b-modal>
    <!-- / modal-->
  </header>
</template>

